<template>
  <v-layout row align-content-space-between align-center>
    <v-flex>
      <v-layout row align-content-start align-center>
        <v-flex v-if="this.showIcon" class="icon" shrink>
          <v-icon>check</v-icon>
        </v-flex>
        <v-flex class="task-details" v-bind:class="{ smaller: smaller }">
          <div>
            {{ itemData.dateTime | moment("M/D") }} |
            {{ itemData.dateTime | moment("h:mma") }}
          </div>
          <div>
            {{ itemData.taskName }}
          </div>
          <div>
            {{ itemData.notes || 'notes here' }}
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex>
      <v-layout row justify-end>
        <v-btn
          v-if="itemData.completed"
          color="success"
          small
          @click="markIncomplete"
          :loading="apiCallPending"
        >
          <v-icon
            left
          > check </v-icon>
          Completed
        </v-btn>

        <v-btn
          v-else
          color="gray"
          small
          @click="markComplete"
          :loading="apiCallPending"
        >
          Incomplete
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    showIcon: Boolean,
    smaller: Boolean,
    itemData: Object
  },
  data: function() {
    return {
      apiCallPending: false
    }
  },
  computed: {
  },
  methods: {
    markComplete () {
      this.apiCallPending = true
      this.$store.dispatch('tasks/markComplete', this.itemData).finally(res => {
        this.apiCallPending = false
      })
    },
    markIncomplete () {
      this.apiCallPending = true
      this.$store.dispatch('tasks/markIncomplete', this.itemData).finally(res => {
        this.apiCallPending = false
      })
    },
  }
}
</script>

<style scoped>
.icon {
  display: inline-block;
}

.task-details {
  display: inline-block;
}

.smaller {
  font-size: 0.8em;
}

.smaller-icon {
  font-size: 0.9em;
}
</style>
